<template>
    <div class="box">
        <div
            :class="[update ? 'open' : 'close', 'title']"
            @click="
                if (!disable) {
                    update = !update;
                }
            "
        >
            随货资料<img src="../assets/arrow  down@2x.png" alt="" v-if="!disable" />
        </div>
        <div v-show="!update" style="margin-top:20px">
            <a-tabs type="card" @change="callback">
                <a-tab-pane :tab="item.name" v-for="(item, index) in list" :key="index">
                    <a-checkbox-group @change="onChange" :default-value="defaultValue">
                        <a-checkbox :value="otem" v-for="(otem, i) in item.content" :key="i">
                            {{ otem }}
                        </a-checkbox>
                    </a-checkbox-group>
                </a-tab-pane>
            </a-tabs>
        </div>
        <div class="flex">
            <div class="selected">
                <div>
                    已选择：
                </div>
            </div>
            <div class="content">
                <div v-for="(item, index) in orcContent2" :key="index" class="selectexd">
                    <div>{{ item.name }}：</div>
                    <div v-for="(otem, i) in item.info" :key="i" style="margin-left:5px">{{ otem }}</div>
                </div>
            </div>
        </div>
        <div class="btn">
            <a-button type="primary" v-if="update && !disable" @click="update = false">修改</a-button>
            <a-button type="primary" v-if="!update" @click="ok">保存</a-button>
        </div>
    </div>
</template>

<script>
// import { getWithGoods, subWithGoods } from '@/api/withGoods'
export default {
    props: {
        orcContent: {
            type: Array
        },
        uuid: {
            type: String
        },
        storeId: {
            type: String
        },
        disable: {
            type: Boolean
        }
    },
    data() {
        return {
            update: false,
            list: [],
            isTabe: 0,
            defaultValue: [],
            arr: {},
            orcContent2: []
        };
    },
    mounted() {
        this.getData();
        if (this.disable) {
            this.update = true;
        }
    },
    watch: {
        orcContent: {
            handler(val, oval) {
                if (val) {
                    // debugger
                    val.forEach(item => {
                        this.$set(this.arr, item.name, item.info);

                        // this.arr[item.name] = item.infor
                    });
                    this.defaultValue = val[0].info;
                }
            },
            deep: true,
            immediate: true
        },
        arr: {
            handler(val, oval) {
                let orcContent = [];
                for (let key in val) {
                    orcContent.push({
                        name: key,
                        info: val[key]
                    });
                }
                this.orcContent2 = orcContent;
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        callback(e) {
            this.isTabe = e;
            if (this.orcContent && this.orcContent[this.isTabe]) {
                this.defaultValue = this.orcContent[this.isTabe].info;
            }
        },
        onChange(checkedValues) {
            // if (this.orcContent == null) {
            // this.arr.push({
            //   name: this.list[this.isTabe].name,
            //   info: checkedValues
            // })
            // this.arr = []
            // this.arr[this.isTabe] = {
            //   name: this.list[this.isTabe].name,
            //   info: checkedValues
            // }
            // } else {
            //   this.arr[this.isTabe].info = checkedValues
            // }
            if (checkedValues.length > 0) {
                this.$set(this.arr, this.list[this.isTabe].name, checkedValues);
                // this.arr[this.list[this.isTabe].name] = checkedValues
            } else {
                this.$delete(this.arr, this.list[this.isTabe].name);
            }
        },
        ok() {
            this.update = true;
            const list = {
                uuid: this.uuid,
                orcContent: this.orcContent2
            };
            this.api.subWithGoods(list).then(res => {
                if (res.ok) {
                    this.$message.info(res.message);
                    this.$emit('getData');
                } else {
                    this.$message.error(res.message);
                }
            });
        },
        getData() {
            this.api.getWithGoods({ storeId: this.storeId }).then(res => {
                if (res.data) {
                    res.data.forEach(item => {
                        item.content = JSON.parse(item.content);
                    });
                    this.list = res.data;
                }
            });
        }
    }
};
</script>

<style lang="less" scoped>
.box {
    .title {
        height: 28px;
        font-size: 18px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 6 00;
        color: #333333;
        line-height: 28px;
        display: flex;
        align-items: center;
        img {
            width: 16px;
            height: 8px;
            margin-left: 10px;
        }
    }
    .close {
        img {
            transform: rotate(180deg);
        }
    }
    .flex {
        display: flex;
        margin: 20px 0 0 0;
    }
    margin: 10px 0;
    .selected {
        width: 5%;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
        line-height: 22px;
    }
    .content {
        width: 88%;
        margin-right: 1%;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 22px;
        .selectexd {
            display: flex;
        }
    }
    .btn {
        margin-top: 10px;
        width: 6%;
    }
}
div {
    cursor: default;
}
</style>



// WEBPACK FOOTER //
// src/components/withGoods.vue